import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IUnmanagedBusiness } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { convertLeadTimeToDays } from '@/coreDomainsModule/leadtime';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  AggregateBusinessPostRequest,
  ExistsAggregateBusinessParameters,
  ExistsAggregateBusinessSuccessAllOfResult,
} from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 集計取引が存在するかどうかを確認する
 * （在庫・入荷の場合に使用）
 */
export class CheckDuplicateAggregateBusinessUseCase {
  /**
   * 集計取引が存在するかどうかを確認する
   * @param repository - 取引情報のリポジトリ
   * @param business - 取引情報
   * @returns 存在しているかをBool値で返す
   */
  static async execute(
    repository: IAggregateBusinessRepository,
    business: IUnmanagedBusiness
  ): Promise<INetworkResult<ExistsAggregateBusinessSuccessAllOfResult, Error>> {
    try {
      const parameters: ExistsAggregateBusinessParameters = {
        warehouseNumber: business.warehouseNumber,
        supplierNumber: business.supplierNumber,
        businessNumber: business.businessNumber,
        package: Number(business.package),
        unit: business.unit,
        leadTime: business.leadTime && business.leadTimeUnit ? convertLeadTimeToDays(business.leadTime, business.leadTimeUnit) : undefined,
        leadTimeUnit: business.leadTimeUnit,
        stdInventoryIndicesMin: business.stdInventoryIndices?.標準在庫指数.min,
        stdInventoryIndicesMax: business.stdInventoryIndices?.標準在庫指数.max,
        stdInventoryIndicesUnit: business.stdInventoryIndices?.標準在庫指数.option.unit,
        moq: business.moq,
      };
      const result = await repository.checkDuplicateAggregateBusiness(parameters);

      if (result.status.type === 'error') {
        return {
          status: {
            type: 'error',
            error: Error('取引情報の作成に失敗しました'),
          },
        };
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取引情報の作成に失敗しました'),
        },
      };
    }
  }
}
